import * as t from 'io-ts';
import { LoyaltyTransactionDynamicType } from './loyaltyTransaction';

export const LoyaltyTransactionsListDynamicType = t.interface({
    transactions: t.array(LoyaltyTransactionDynamicType)
});

export type LoyaltyTransactionsList = t.TypeOf<typeof LoyaltyTransactionsListDynamicType>;
